export const evaluateRules = (passwordValidationRules, newPassword, newPasswordConfirm, currentPassword = null, passwordValidationUserData = null) => {

    const result = {
        allowConfirmPassword: false,
        passwordsMatch: false,
        allowChangePassword: false
    };

    if (passwordValidationRules.length.enabled) {
        passwordValidationRules.length.passed = newPassword.length >= passwordValidationRules.length.digits;
    }
    if (passwordValidationRules.upperChars.enabled) {
        passwordValidationRules.upperChars.passed = countMatches(newPassword, new RegExp("[A-Z]", "g")) >= passwordValidationRules.upperChars.digits;
    }
    if (passwordValidationRules.lowerChars.enabled) {
        passwordValidationRules.lowerChars.passed = countMatches(newPassword, new RegExp("[a-z]", "g")) >= passwordValidationRules.lowerChars.digits;
    }
    if (passwordValidationRules.alpha.enabled) {
        passwordValidationRules.alpha.passed = countMatches(newPassword, new RegExp("[A-Za-z]", "g")) >= passwordValidationRules.alpha.digits;
    }
    if (passwordValidationRules.special.enabled) {
        passwordValidationRules.special.passed = countMatches(newPassword, new RegExp("[^a-zA-Z0-9]", "g")) >= passwordValidationRules.special.digits;
    }
    if (passwordValidationRules.numbers.enabled) {
        passwordValidationRules.numbers.passed = countMatches(newPassword, new RegExp("[0-9]", "g")) >= passwordValidationRules.numbers.digits;
    }
    if (passwordValidationRules.maxConsecutiveChars.enabled) {
        passwordValidationRules.maxConsecutiveChars.passed = !containsSubstring(newPassword, passwordValidationUserData, passwordValidationRules.maxConsecutiveChars.digits + 1);
    }
    var allowChangePassword = true;
    allowChangePassword = allowChangePassword && passwordValidationRules.length.passed;

    if (passwordValidationRules.upperChars.enabled) {
        allowChangePassword = allowChangePassword && passwordValidationRules.upperChars.passed;
    }
    if (passwordValidationRules.lowerChars.enabled) {
        allowChangePassword = allowChangePassword && passwordValidationRules.lowerChars.passed;
    }
    if (passwordValidationRules.special.enabled) {
        allowChangePassword = allowChangePassword && passwordValidationRules.special.passed;
    }
    if (passwordValidationRules.numbers.enabled) {
        allowChangePassword = allowChangePassword && passwordValidationRules.numbers.passed;
    }
    if (passwordValidationRules.alpha.enabled) {
        allowChangePassword = allowChangePassword && passwordValidationRules.alpha.passed;
    }
    if (passwordValidationRules.maxConsecutiveChars.enabled) {
        allowChangePassword = allowChangePassword && passwordValidationRules.maxConsecutiveChars.passed;
    }
    result.allowConfirmPassword = allowChangePassword;
    result.allowChangePassword = allowChangePassword && (currentPassword != null && currentPassword.length > 0);
    if (result.allowConfirmPassword) {
        result.passwordsMatch = newPassword == newPasswordConfirm;
        result.allowChangePassword = allowChangePassword && result.passwordsMatch;
    }
    return result;
};

export const countMatches = (str, regExp) => {
    var count = 0;
    while (regExp.exec(str) != null) {
        count++;
    }

    return count;
};

export const containsSubstring = (stringToMatch, userData, substringLength) => {
    if (!stringToMatch || !userData) {
        return false;
    }

    if (substringLength < 1 || stringToMatch.length < substringLength) {
        return false;
    }

    const stringToMatchSubstrings = splitString(stringToMatch, substringLength);
    const userDataValues = Object.values(userData);
    const matchedSubstrings = stringToMatchSubstrings.filter((substring) => {
        return userDataValues.some((userProp) => containsSubstringIgnoreCase(userProp, substring));
    });

    return matchedSubstrings.length > 0;
};

const splitString = (stringToSplit, substringLength) => {
    const stringParts = [];
    for (let startIndex = 0; startIndex < stringToSplit.length; startIndex++) {
        const endIndexExclusive = startIndex + substringLength;
        if (endIndexExclusive > stringToSplit.length) {
            break;
        }

        const substring = stringToSplit.substring(startIndex, endIndexExclusive);
        stringParts.push(substring);
    }

    return stringParts;
};

const containsSubstringIgnoreCase = (userProp, substring) => {
    if (!userProp || !substring) {
        return false;
    }
    userProp = userProp.toLowerCase();
    substring = substring.toLowerCase();

    return userProp.indexOf(substring) !== -1;
};
